import PropTypes from "prop-types";
import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, Link as RouterLink, useParams } from "react-router-dom";

import { Grid, Button, IconButton, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import IndexTable from "../../components/Layout/IndexTable";
import { PromoContext } from "../../context";
import { PermissionedDisplay, SectionGridContainer } from "../../components/Layout";
import Permissions from "../../permissions";
import usePromoColumns from "./usePromoColumns";

const useStyles = makeStyles((theme) => ({
  backButton: { marginRight: theme.spacing(1) },
  buttonBackground: { background: theme.palette.primary.red },
  description: { padding: "24px 12px" },
  scroll: {
    width: "100%",
    overflowX: "scroll",
  },
}));

const PromoGroupDetail = ({ handleShowTabs }) => {
  const DEFAULT_TABLE_ROWS = 100;
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { promoGroupId } = useParams();
  const {
    activePromoGroup,
    getPromoCodesByGroup,
    getActivePromoGroup,
    promoCodesByGroup,
    promoCodesCount,
  } = useContext(PromoContext);

  const fetchPromoCodes = async ({ ordering, page, page_size }) => {
    const { promo_code_type: promoCodeType, id: groupId } = activePromoGroup;
    return getPromoCodesByGroup(groupId, promoCodeType, ordering, page_size, page);
  };

  useEffect(() => {
    handleShowTabs(false);
    if (activePromoGroup?.id !== promoGroupId) getActivePromoGroup(promoGroupId);
  }, [promoGroupId]);

  useEffect(() => {
    if (activePromoGroup) fetchPromoCodes({});
  }, [activePromoGroup?.id, history.location]);

  const promoColumns = (usePromoColumns(activePromoGroup?.promo_code_type) || []).slice(1);

  return (
    <SectionGridContainer>
      <Grid container spacing={2}>
        <Grid item container xs={12} justify="space-between">
          <Grid item container alignItems="center" xs={12} md={6} lg={6}>
            <IconButton className={classes.backButton} component={RouterLink} to="/promo-groups">
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">{activePromoGroup?.name}</Typography>
          </Grid>
          <Grid item container justify="flex-end" xs={12} md={6}>
            <PermissionedDisplay permission={[Permissions.readPromos, Permissions.writePromos]}>
              <Button
                className={classes.buttonBackground}
                onClick={() =>
                  history.push(`/promo-groups/${activePromoGroup.id}/edit`, {
                    background: location,
                  })
                }
              >
                {t("Promos.Table.EditGroup")}
              </Button>
            </PermissionedDisplay>
          </Grid>
          <Grid className={classes.description} item xs={12} lg={12}>
            <Typography>{activePromoGroup?.description}</Typography>
          </Grid>
        </Grid>
      </Grid>
      {activePromoGroup && (
        <IndexTable
          muiTableProps={{
            size: "small",
            stickyHeader: true,
          }}
          columns={promoColumns}
          rows={promoCodesByGroup}
          totalRowsCount={promoCodesCount}
          defaultRowsPerPage={DEFAULT_TABLE_ROWS}
          fetchResource={fetchPromoCodes}
        />
      )}
    </SectionGridContainer>
  );
};

PromoGroupDetail.propTypes = {
  handleShowTabs: PropTypes.func.isRequired,
};

export default PromoGroupDetail;
